import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getFollowSelectedVehicle, getIsFullMissionRouteVisible, getSelectedVehicle } from 'store/slices/appSlice';

import type { VehicleV2 } from 'API';

const useCenterVehicle = (vehicle?: VehicleV2) => {
    const ZOOM_LEVEL = 11;
    const isVehicleFocused = useSelector(getFollowSelectedVehicle);
    const selectedVehicleState = useSelector(getSelectedVehicle);
    const hasMission = useSelector(getIsFullMissionRouteVisible);
    const position = vehicle?.position?.value?.position;

    let center;
    let zoom;

    const calculateCenter = () => {
        if (
            position?.latitude &&
            position?.longitude &&
            !hasMission &&
            (selectedVehicleState.pvlTriggered || isVehicleFocused)
        ) {
            center = {
                lat: position.latitude,
                lng: position.longitude,
            };
        }
    };

    const calculateZoom = () => {
        if ((vehicle && selectedVehicleState.pvlTriggered) || (isVehicleFocused && !hasMission)) {
            zoom = ZOOM_LEVEL;
        }
    };

    const reset = () => {
        center = undefined;
        zoom = undefined;
    };

    useEffect(() => {
        calculateCenter();
        calculateZoom();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [position?.latitude, position?.longitude, center, zoom]);

    calculateCenter();
    calculateZoom();

    return { center, zoom, reset };
};

export default useCenterVehicle;
